export const GAME_LAUNCH_METHODS = Object.freeze({
    REDIRECT_IN_NEW_WINDOW: 'redirectInNewWindow',
    REDIRECT_IN_THIS_WINDOW: 'redirectInThisWindow',
    WRAPPER_IN_NEW_WINDOW: 'wrapperInNewWindow',
    WRAPPER_IN_THIS_WINDOW: 'wrapperInThisWindow'
});

export const GAME_LAUNCH_TYPE = {
    CASINO: 'Casino',
    DEFAULT: 'Default'
};
